import '@vfde-brix/button/dist/styles.css';

import { createButtonComponent } from '@vfde-brix/button';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';

const elements = document.getElementsByClassName('brix-button');

for (let i = 0, x = elements.length; i < x; i += 1) {

    // traversing one up to get the container element
    const containerElement = elements[i].parentElement;

    createButtonComponent(containerElement, NO_PATTERN_BUSINESS_LOGIC);

}
